<template>
  <v-container fluid>
    <v-slide-y-transition mode="out-in">
      <v-row>
        <v-col>
          <CommonTable :keyword="keyword" />
        </v-col>
      </v-row>
    </v-slide-y-transition>
  </v-container>
</template>

<script>
import CommonTable from '../components/CommonTable.vue';
import TitleComponent from '../components/TitleComponent.vue';

export default {
  components: { CommonTable, TitleComponent },
  data() {
    return {
      keyword: 'reduced',
      dataFields: [
        { name: "barcode", caption: "Id", visible: false },
        { name: "difference", caption: "No.", alignment: "right" },
        { name: "id", caption: "Code", alignment: "right" },
        { name: "inspection", caption: "Country" },
        { name: "jobImportDate", caption: "Bov" },
        { name: "jobMadeDate", caption: "Eov" },
        { name: "jobNumber", caption: "Brand" },
        { name: "metarialItemCode", caption: "Product name", width: "250px" },
        { name: "metarialLength", caption: "Atc" },
        { name: "metarialQuality", caption: "Dosage form" },
        { name: "metarialRestLength", caption: "Nou", alignment: "right" },
        { name: "metarialRestWeight", caption: "Package" },
        { name: "originalMetarialQuality", caption: "GRP", alignment: "right" },
        { name: "partsLength", caption: "GRP / unit", alignment: "right" },
        { name: "partsWeight", caption: "MP", alignment: "right" },
        { name: "pceId", caption: "MP / unit", alignment: "right" },
        { name: "pceLength", caption: "NRP", alignment: "right" },
        { name: "pceSign", caption: "NRP / unit", alignment: "right" },
        { name: "pceSurface", caption: "WP", alignment: "right" },
        { name: "pceWeight", caption: "WP / unit", alignment: "right" },
        { name: "productId", caption: "INN & Strength" },
        { name: "productName", caption: "INN & Strength" },
        { name: "profilCode", caption: "INN & Strength" },
        { name: "profilName", caption: "INN & Strength" },
        { name: "profilUnitWeightKgPerM", caption: "INN & Strength" },
        { name: "projectAndPhase", caption: "INN & Strength" },
        { name: "quantity", caption: "INN & Strength" },
        { name: "rowNumber", caption: "INN & Strength" },
        { name: "technicalWaste1", caption: "INN & Strength" },
        { name: "technicalWaste2", caption: "INN & Strength" },
        { name: "tripleCode", caption: "INN & Strength" },
        { name: "wasteLength", caption: "INN & Strength" },
        { name: "wasteWeight", caption: "INN & Strength" },
        { name: "wsId", caption: "INN & Strength" },
        { name: "wsName", caption: "INN & Strength" },
      ]
    }
  },
};
</script>